import axios from 'axios';
import { useEffect, useState } from 'react'
import { Avatar, Button, CircularProgress, Dialog, IconButton, Menu, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import { useSnackbar } from 'notistack';
import { ProjectConfig } from 'Global';
import AlertDialog from 'elements/AlertDialog';
import LogicEditor from './LogicEditor';
import ListPagination from 'elements/ListPagination';
import 'assets/css/main.css';
import { ApiRequest } from 'GlobalFunctions';

export default function PlanList(props: any) {

  const { setLoading } = props;

  const { enqueueSnackbar } = useSnackbar();
  const [list, setList] = useState<any[]>([]);
  const [pagination, setPagination] = useState({
    total_pages: 1,
    total_items: 0,
  });
  const currentPage = 1;
  const [page, setPage] = useState(currentPage);
  const [openEditor, setOpenEditor] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const [activeItem, setActiveItem] = useState<any>(null);
  const [openAlert, setOpenAlert] = useState(false);

  useEffect(() => {
    setLoading(true);
    loadList();
  }, [page]);

  /*=========================================================
  LOAD LIST
  =========================================================*/
  const loadList = () => {
    setLoading(true);

    ApiRequest({
      method: 'GET',
      url: '/logic/list',
      query: { page: page },
      setResponse: (response: any) => {
        setList(response.list);
        setPagination(response.pagination);
        setLoading(false);
      }
    })
  }

  /*=========================================================
  DELETE ITEM
  =========================================================*/
  const handleDelete = (logic_id: number) => {
    setActiveItem(logic_id);
    setOpenAlert(true);
  }

  const deleteItem = () => {
    const body = { logic_id: activeItem };
    axios.post(ProjectConfig.api_url + "/logic/deleteItem", body)
      .then((response) => {
        console.log(response.data);
        if (response.data.status === "success") {
          enqueueSnackbar('Item deleted successfully', { variant: 'success' });
          loadList();
        }
      })
      .catch((err) => {
        console.log(err.data);
      })
      .then(() => {
        setOpenAlert(false);
      });
  }

  /*=========================================================
  HANDLE MENU OPEN
  =========================================================*/
  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, item: any) => {
    setMenuAnchor(event.currentTarget);
    setActiveItem(item);
  };

  /*=========================================================
  HANDLE MENU CLOSE
  =========================================================*/
  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  /*=========================================================
  HANDLE EDIT
  =========================================================*/
  const handleEdit = () => {
    setOpenEditor(true);
    handleMenuClose();
  };

  return (
    <div className='ModuleContainer'>
        <div className="ModuleHeader">
          <div className="ComponentTitle">
            <h1>Logic</h1>
          </div>
          <div className="ModuleActions">
            <Button
              variant="outlined"
              color="info"
              onClick={() => {
                setActiveItem(null);
                setOpenEditor(true);
              }}
              className="btnList"
              startIcon={<AddIcon />}
            >
              New Logic Condition
            </Button>
          </div>
        </div>

        
        <div className='ModuleContent'>
          <TableContainer sx={{ width: "100%" }}>
            <Table className="table">
              <TableHead>
                <TableRow>
                  <TableCell>Description</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Created</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((item, i) => (
                  <TableRow key={i} hover role="checkbox">
                    <TableCell>{item.logic_name}</TableCell>
                    <TableCell>{item.logic_type}</TableCell>
                    <TableCell>{item.created_at}</TableCell>
                    <TableCell align="right">
                      <IconButton aria-label="edit" color="primary" onClick={(event) => handleMenuOpen(event, item)}>
                        <MoreHorizIcon />
                      </IconButton>
                      <Menu
                        anchorEl={menuAnchor}
                        open={Boolean(menuAnchor && activeItem && activeItem.logic_id === item.logic_id)}
                        onClose={handleMenuClose}
                      >
                        <MenuItem onClick={() => {
                          setActiveItem(item);
                          setOpenEditor(true);
                          handleMenuClose();
                        }}>
                          <EditIcon fontSize="small" />
                          Edit
                        </MenuItem>
                        <MenuItem onClick={() => handleDelete(item.logic_id)}>
                          <DeleteOutlineOutlinedIcon fontSize="small" />
                          Remove
                        </MenuItem>
                      </Menu>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <ListPagination
            pagination={pagination}
            page={page}
            onChange={(event: any, value: any) => {
              setPage(value);
            }}
            label="Logic"
            style={{ marginTop: "20px", alignSelf: "center" }}
          />
        </div>

      <AlertDialog
        open={openAlert}
        setOpen={setOpenAlert}
        subtitle="Are you sure you want to delete this item?"
        send={deleteItem}
      />

      <LogicEditor
        setLoading={setLoading}
        openEditor={openEditor}
        setOpenEditor={setOpenEditor}
        logic_id={activeItem ? activeItem.logic_id : null}
        loadList={loadList}
      />
    </div>
  );
};
